// Vendor CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import 'lightslider/dist/css/lightslider.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'jssocials/dist/jssocials.css';
import 'jssocials/dist/jssocials-theme-flat.css';
import 'pixeden-stroke-7-icon/pe-icon-7-stroke/dist/pe-icon-7-stroke.min.css';

// Vendor JS
import 'jquery';
import 'bootstrap';
import 'bootstrap-validator';
import 'waypoints';
import 'lightslider';
import WOW from 'wowjs';
import 'jssocials';
import Cookies from 'js-cookie';
import Logger from 'js-logger';

// Expose globals that app code depends on
window.Cookies = Cookies;
window.Logger = Logger;
window.WOW = WOW.WOW || WOW;
